<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link :to="getHomeLink" class="logo logo-light">
            <span class="logo-sm">
              <img src="@/assets/images/nhai.png" width="100%" class="mt-3" />
            </span>
            <span class="logo-lg">
              <img
                src="@/assets/images/nhai-logo-white.png"
                width="100%"
                class="mt-3"
              />
            </span>
          </router-link>
        </div>
        <button
          id="vertical-menu-btn"
          type="button"
          class="btn btn-sm px-3 font-size-16 header-item"
          @click="toggleMenu"
          v-show="currentUser.user.role !== 'rpo'"
        >
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>

      <div class="d-flex">
        <div class="dropdown d-none d-lg-inline-block mt-3 ms-1 me-4">
          <button
            type="button"
            @click="showRaiseNewIncident"
            class="btn btn-info btn-rounded btn-block w-100"
          >
            <i class="mdi mdi-plus me-1"></i>
            {{ $t("menuitems.incident.list.raiseIncident") }}
          </button>
        </div>
        <div
          class="dropdown d-none d-lg-inline-block ms-1 me-4"
          style="margin-top: 28px"
        >
          <div class="btn-group" role="group">
            <label>Live Alerts</label>
            <switches v-model="checked" color="info" class="ms-2"></switches>
          </div>
        </div>

        <b-dropdown
          variant="white"
          right
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <img class :src="flag" alt="Header Language" height="16" />
            <span class="ms-2">{{ text }}</span>
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry.language, entry.title, entry.flag)"
            :class="{ active: current_language === entry.language }"
          >
            <img
              :src="`${entry.flag}`"
              alt="user-image"
              class="me-2"
              height="12"
            />
            <span class="align-middle">{{ entry.title }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <!-- FullscreenVue -->
        <div class="dropdown d-none d-lg-inline-block ms-1">
          <button
            type="button"
            class="btn header-item noti-icon"
            @click="initFullScreen"
          >
            <i class="bx bx-fullscreen"></i>
          </button>
        </div>
        <!-- User -->
        <b-dropdown
          right
          variant="black"
          toggle-class="header-item"
          menu-class="dropdown-menu-end"
        >
          <template v-slot:button-content>
            <span class="d-none d-xl-inline-block ms-1">
              <div v-if="currentUser">
                {{ currentUser.user.first_name }}
              </div>
              <div v-else>User</div>
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>
          <a href="/logout" class="dropdown-item text-danger">
            <i
              class="bx bx-power-off font-size-16 align-middle me-1 text-danger"
            ></i>
            {{ $t("menuitems.dashboards.list.logout") }}
          </a>
        </b-dropdown>
      </div>
    </div>

    <!-- Raise new incident modal -->
    <b-modal
      id="raise-new-incident-modal"
      title="Raise Challan"
      title-class="font-18"
      size="lg"
      no-close-on-backdrop
      hide-footer
      centered
    >
      <template #modal-header>
        <div><h5>Raise New Incident</h5></div>
        <div>
          <button
            class="btn btn-sm btn-outline-danger"
            @click="$bvModal.hide('raise-new-incident-modal')"
          >
            Cancel
          </button>
        </div>
      </template>
      <RaiseNewIncident
        @closeModal="$bvModal.hide('raise-new-incident-modal')"
      />
    </b-modal>
  </header>
</template>

<script>
import axios from "axios";
import simplebar from "simplebar-vue";
import i18n from "../i18n";
import { authComputed } from "@/state/helpers";
import Switches from "vue-switches";
import RaiseNewIncident from "../views/incident/raise-incident.vue";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      languages: [
        {
          flag: require("@/assets/images/flags/us.jpg"),
          language: "en",
          title: "English",
        },
        {
          flag: require("@/assets/images/flags/india.jpg"),
          language: "hi",
          title: "Hindi",
        },
      ],
      checked: null,
      current_language: i18n.locale,
      text: "English",
      flag: require("@/assets/images/flags/us.jpg"),
      value: "en",
      myVar: 1,
    };
  },
  components: { simplebar, Switches, RaiseNewIncident },

  mounted() {
    this.value = this.languages.find((x) => x.language === i18n.locale);
    this.text = this.value.title;
    this.flag = this.value.flag;
    if (!this.currentUser) {
      this.$router.push("/logout");
    }
    this.checked = this.$store.getters["incident/liveAlert"];
  },

  methods: {
    showRaiseNewIncident() {
      this.$bvModal.show("raise-new-incident-modal");
    },
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar();
    },
    initFullScreen() {
      document.body.classList.toggle("fullscreen-enable");
      if (
        !document.fullscreenElement &&
        /* alternative standard method */ !document.mozFullScreenElement &&
        !document.webkitFullscreenElement
      ) {
        // current working methods
        if (document.documentElement.requestFullscreen) {
          document.documentElement.requestFullscreen();
        } else if (document.documentElement.mozRequestFullScreen) {
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullscreen) {
          document.documentElement.webkitRequestFullscreen(
            Element.ALLOW_KEYBOARD_INPUT
          );
        }
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        }
      }
    },
    setLanguage(locale, country, flag) {
      this.current_language = locale;
      this.text = country;
      this.flag = flag;
      i18n.locale = locale;
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      axios.get("http://127.0.0.1:8000/api/logout").then((res) => {
        this.$router.push({
          name: "default",
        });
      });
    },
  },
  watch: {
    checked: function () {
      this.$store.dispatch("incident/updateLiveAlert", this.checked);
    },
  },
  computed: {
    ...authComputed,
    getHomeLink() {
      return this.currentUser.user.role === "rpo" ? "/rpo/dashboard" : "/";
    },
    currentUser() {
      return this.$store.getters["auth/user"];
    },

    liveAlert() {
      return this.$store.getters["incident/liveAlert"];
    },
  },
};
</script>
